export default "__VITE_ASSET__CxWbz6g$__"